

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchTagPageProjectsCount } from 'shared/actions/tagPageActions';

export enum tagPageCategories {
    bestProjects = 'bestProjects',
    portfolio = 'portfolio',
    education = 'education',
    competitions = 'competitions',
    experts = 'experts'
}

interface ITagPageSlice {
    currentCategory: tagPageCategories;
    categoryProjectsCount?: number;
    data: any[];
    counts: any[];
    isFetching: boolean;
    isModerOrExpert: boolean;
}

const initialState = {
    currentCategory: tagPageCategories.bestProjects,
    categoryProjectsCount: 0,
    counts: [],
    isModerOrExpert: false,
    data: [],
    isFetching: false,
} as ITagPageSlice;

const TagPageSlice = createSlice({
    name: 'tagPage',
    initialState,
    reducers: {
        setCurrentPage(state, action: PayloadAction<tagPageCategories>) {
            state.currentCategory = action.payload;
        },
        setCategoryProjectsCount(state, action: PayloadAction<number>) {
            state.categoryProjectsCount = action.payload;
        },
        setModerOrExpert(state, action: PayloadAction<boolean>) {
            state.isModerOrExpert = action.payload;
        },
    },
    extraReducers: {
        [fetchTagPageProjectsCount.fulfilled.toString()]: (state, action) => {
            state.counts = action.payload;
            state.isFetching = false;
        },
        [fetchTagPageProjectsCount.rejected.toString()]: (state, action) => {
            state.counts = [];
            state.isFetching = false;
        },
        [fetchTagPageProjectsCount.pending.toString()]: (state, action) => {
            state.counts = [];
            state.isFetching = true;
        },
    }
});

export const { setCurrentPage, setCategoryProjectsCount, setModerOrExpert  } = TagPageSlice.actions;
export const TagPageSelector = (store: { tagPage: ITagPageSlice }): ITagPageSlice => store.tagPage;
export default TagPageSlice;


import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchTagPageProjectsCount } from 'shared/actions/tagPageActions';

export enum tagPageCategories {
    bestProjects = 'bestProjects',
    portfolio = 'portfolio',
    education = 'education',
    competitions = 'competitions',
    experts = 'experts'
}

interface ITagPageSlice {
    currentCategory: tagPageCategories;
    categoryProjectsCount?: number;
    data: any[];
    counts: any[];
    isFetching: boolean;
    isModerOrExpert: boolean;
}

const initialState = {
    currentCategory: tagPageCategories.bestProjects,
    categoryProjectsCount: 0,
    counts: [],
    isModerOrExpert: false,
    data: [],
    isFetching: false,
} as ITagPageSlice;

const TagPageSlice = createSlice({
    name: 'tagPage',
    initialState,
    reducers: {
        setCurrentPage(state, action: PayloadAction<tagPageCategories>) {
            state.currentCategory = action.payload;
        },
        setCategoryProjectsCount(state, action: PayloadAction<number>) {
            state.categoryProjectsCount = action.payload;
        },
        setModerOrExpert(state, action: PayloadAction<boolean>) {
            state.isModerOrExpert = action.payload;
        },
    },
    extraReducers: {
        [fetchTagPageProjectsCount.fulfilled.toString()]: (state, action) => {
            state.counts = action.payload;
            state.isFetching = false;
        },
        [fetchTagPageProjectsCount.rejected.toString()]: (state, action) => {
            state.counts = [];
            state.isFetching = false;
        },
        [fetchTagPageProjectsCount.pending.toString()]: (state, action) => {
            state.counts = [];
            state.isFetching = true;
        },
    }
});

export const { setCurrentPage, setCategoryProjectsCount, setModerOrExpert  } = TagPageSlice.actions;
export const TagPageSelector = (store: { tagPage: ITagPageSlice }): ITagPageSlice => store.tagPage;
export default TagPageSlice;
